import { FetchJsonProps, useReactQueryFetchJson } from '@apeiron/temp'
import ENV_CONFIG from '@src/config'
import useMakeActivityFilter from '@src/deserialize/hook/useMakeActivityFilter'
import { ActivityFilterData } from '@src/types/activityFilter'

const useFetchActivityFilterJson = (props?: FetchJsonProps) => {
  const { fetchNow } = props || {}

  const { makeActivityFilter } = useMakeActivityFilter()

  return useReactQueryFetchJson<ActivityFilterData>({
    fetchNow,
    path: ENV_CONFIG.JSON_FILE_NAME.ACTIVTY_FILTERS,
    deserialize: makeActivityFilter
  })
}

export default useFetchActivityFilterJson
